import React from 'react';
import styles from './TilesWrapper.styles.scss';
import cn from 'classnames';

const TilesWrapper = ({ children, className }) => {
  return (
    <div className="d-flex w-100 align-items-center flex-column flex-1">
      <div className={cn(styles.wrapper, className)}>{children}</div>
    </div>
  );
};

export default React.memo(TilesWrapper);
